/* ============================== */
/*  CONFIGURATION OBJECTS         */
/* ============================== */

const dutyRules = {
  /* ---- Threshold-based ---- */
  USD:{type:'threshold',value:800,  messageBelow:'Import duties included',          messageAbove:'Import duties included'}, // US: you include duties
  AUD:{type:'threshold',value:1000, messageBelow:'Import duties included',          messageAbove:'Import duties excluded'},
  CAD:{type:'threshold',value:150,  messageBelow:'Import duties included',          messageAbove:'Import duties excluded'},
  GBP:{type:'threshold',value:135,  messageBelow:'Import duties included',          messageAbove:'Import duties excluded'},
  JPY:{type:'threshold',value:10000,messageBelow:'Import duties included',          messageAbove:'Import duties excluded'},
  MYR:{type:'threshold',value:500,  messageBelow:'Import duties included',          messageAbove:'Import duties excluded'},
  MXN:{type:'threshold',value:1000, messageBelow:'Import duties included',          messageAbove:'Import duties excluded'},
  PHP:{type:'threshold',value:10000,messageBelow:'Import duties included',          messageAbove:'Import duties excluded'},
  SAR:{type:'threshold',value:1000, messageBelow:'Import duties included',          messageAbove:'Import duties excluded'},
  SGD:{type:'threshold',value:400,  messageBelow:'Import duties included',          messageAbove:'Import duties excluded'},
  KRW:{type:'threshold',value:200000,messageBelow:'Import duties included',         messageAbove:'Import duties excluded'},
  TWD:{type:'threshold',value:2000, messageBelow:'Import duties included',          messageAbove:'Import duties excluded'},
  THB:{type:'threshold',value:1500, messageBelow:'Import duties included',          messageAbove:'Import duties excluded'},
  AED:{type:'threshold',value:1000, messageBelow:'Import duties included',          messageAbove:'Import duties excluded'},
  NZD:{type:'threshold',value:1000, messageBelow:'Import duties included',          messageAbove:'Import duties excluded'},
  ILS:{type:'threshold',value:280,  messageBelow:'Import duties included',          messageAbove:'Import duties excluded'},
  CLP:{type:'threshold',value:28000,messageBelow:'Import duties included',          messageAbove:'Import duties excluded'},
  /* ---- Always applies ---- */
  ARS:{type:'always',message:'Import duties excluded'},
  AZN:{type:'always',message:'Import duties excluded'},
  BRL:{type:'always',message:'Import duties excluded'},
  KHR:{type:'always',message:'Import duties excluded'},
  CNY:{type:'always',message:'Import duties excluded'},
  IDR:{type:'always',message:'Import duties excluded'},
  RUB:{type:'always',message:'Import duties excluded'},
  ZAR:{type:'always',message:'Import duties excluded'},
  CHF:{type:'always',message:'Import duties excluded'},
  TRY:{type:'always',message:'Import duties excluded'},
  VND:{type:'always',message:'Import duties excluded'},
  INR:{type:'always',message:'Import duties excluded'},
  NOK:{type:'always',message:'Import duties excluded'},
  /* ---- Free-port ---- */
  HKD:{type:'free',  message:'Import duties included'}
};

/* EU currencies used by EU members (2025): EUR + 7 non-euro */
const euCurrencies = ['EUR','BGN','CZK','DKK','HUF','PLN','RON','SEK']; // HRK/ISK removed

/* ============================== */
/*  HELPERS                       */
/* ============================== */
function computeMessage(currency, price) {
  const c = String(currency || 'USD').toUpperCase();

  // US: you include duties in the final price → always "included"
  if (c === 'USD') return 'Import duties included';

  if (euCurrencies.includes(c)) return 'VAT included';

  const rule = dutyRules[c];
  if (!rule) return 'Import duties excluded';

  if (rule.type === 'threshold') return price >= rule.value ? rule.messageAbove : rule.messageBelow;
  if (rule.type === 'free')      return 'Import duties included';
  return rule.message; // 'always'
}

function updateAllTaxesNotices(e) {
  // Support product page, cart drawer, and any legacy ids created by sections
  const notices = document.querySelectorAll('#taxes-notice, #taxes-notice-cart');
  if (!notices.length) return;

  // If a variant change supplied a price (in cents), prefer it for product-scope
  const variantPriceCents = e?.detail?.variant?.price;
  const variantPrice = (typeof variantPriceCents === 'number') ? (variantPriceCents / 100) : undefined;

  notices.forEach((el) => {
    let price = parseFloat(el.dataset.price || '0');
    // If this is in the same area as the variant event, update the dataset price
    if (variantPrice !== undefined) {
      try {
        const scope = e?.target?.closest?.('.product-info, form[action*="/cart/add"]') || null;
        if (!scope || (scope && el.closest && scope.contains(el))) {
          price = variantPrice;
          el.dataset.price = String(price);
        }
      } catch (_) {}
    }

    // Prefer explicit data-currency; fallback to Shopify currency
    const currency = (el.dataset.currency || (window.Shopify?.currency?.active ?? 'USD'));
    el.textContent = computeMessage(currency, price);
  });
}

/* ---- Fallback price updater (localized, keeps symbols) ---- */
function formatMoneyLocalized(cents, currency, locale) {
  const amount = (cents || 0) / 100;
  const cur = currency || (window.Shopify?.currency?.active) || window.Shopify?.shop_currency || 'USD';
  const loc = locale || window.Shopify?.locale || navigator.language || 'en';
  try {
    return new Intl.NumberFormat(loc, { style: 'currency', currency: String(cur).toUpperCase() }).format(amount);
  } catch (_) {
    // Safe fallback if Intl cannot format this currency
    return amount.toLocaleString(loc, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + cur;
  }
}

function updateDisplayedPrices(e) {
  const v = e?.detail?.variant;
  if (!v) return;

  // Scope to the product whose options changed
  const scope = e.target?.closest?.('.product-info') || document;

  // Prestige renders prices inside <price-list class="price-list--product">
  const priceList = scope.querySelector('price-list.price-list--product');
  if (!priceList) return;

  const saleEl    = priceList.querySelector('sale-price');
  const compareEl = priceList.querySelector('compare-at-price');

  // Use Markets active currency + locale
  const currency = window.Shopify?.currency?.active || window.Shopify?.shop_currency || 'USD';
  const locale   = window.Shopify?.locale || navigator.language;

  if (saleEl) {
    const sr = saleEl.querySelector('.sr-only')?.outerHTML || '<span class="sr-only">Price</span>';
    saleEl.innerHTML = sr + ' ' + formatMoneyLocalized(v.price, currency, locale);
  }

  if (compareEl) {
    if (v.compare_at_price && v.compare_at_price > v.price) {
      const sr = compareEl.querySelector('.sr-only')?.outerHTML || '<span class="sr-only">Regular price</span>';
      compareEl.innerHTML = sr + ' ' + formatMoneyLocalized(v.compare_at_price, currency, locale);
      compareEl.style.display = ''; // ensure visible
    } else {
      compareEl.style.display = 'none';
    }
  }

  // Keep the taxes notice in sync too
  try {
    const taxes = scope.querySelector('#taxes-notice');
    if (taxes) {
      taxes.dataset.price = String(v.price / 100);
      if (typeof updateAllTaxesNotices === 'function') updateAllTaxesNotices(e);
    }
  } catch (_) {}
}

/* ---------- CART DRAWER OBSERVER (ensures notice shows after add-to-cart) ---------- */
(function initCartDrawerObserver(){
  // simple debounce to avoid spamming updates during large DOM replacements
  let timer = null;
  const debounce = (fn, t = 80) => (...args) => { clearTimeout(timer); timer = setTimeout(() => fn(...args), t); };

  const handleChange = debounce(() => {
    // If the cart notice exists, (re)populate it
    if (document.getElementById('taxes-notice-cart')) {
      if (typeof updateAllTaxesNotices === 'function') updateAllTaxesNotices();
    }
  });

  const start = () => {
    const root = document.getElementById('cart-drawer') || document.body;
    if (!root) return;  // try again after DOM ready
    try {
      const observer = new MutationObserver(handleChange);
      observer.observe(root, { childList: true, subtree: true });
    } catch(_) {}
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // also try when cart opens (some themes dispatch these)
  ['cart:open','cart:drawer:open','cart:refresh','cart:updated','cart:change'].forEach(evt =>
    document.addEventListener(evt, handleChange)
  );
})();

/* ---------- CART DRAWER HOOK (safe, short-lived) ---------- */
(function initCartDrawerHook(){
  let observer = null;

  function runUpdate() {
    if (typeof updateAllTaxesNotices === 'function') {
      updateAllTaxesNotices();
    }
  }

  function attachShortObserver() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    // Disconnect any previous observer
    if (observer) { try { observer.disconnect(); } catch(_) {} observer = null; }

    // Observe ONLY the cart drawer, for a very short window, and only childList
    observer = new MutationObserver(() => {
      // As soon as our target node exists once, update and stop observing
      if (document.getElementById('taxes-notice-cart')) {
        runUpdate();                    // immediate
        setTimeout(runUpdate, 60);      // after next layout
        setTimeout(runUpdate, 200);     // after potential second fragment swap
        try { observer.disconnect(); } catch(_) {}
        observer = null;
      }
    });

    try {
      observer.observe(drawer, { childList: true, subtree: true });
    } catch(_) {}
  }

  function onCartEvent() {
    // Nudge updates in case the node is already there
    runUpdate();
    setTimeout(runUpdate, 60);
    setTimeout(runUpdate, 200);
    // Then watch briefly for the next DOM swap
    attachShortObserver();
  }

  // Common cart events fired by Shopify themes (Prestige uses some of these)
  ['cart:open','cart:drawer:open','cart:refresh','cart:updated','cart:update','cart:change','ajaxProduct:added','product:added']
    .forEach(evt => document.addEventListener(evt, onCartEvent));

  // If the drawer is already open at load (rare), kick once
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      if (document.getElementById('cart-drawer')?.hasAttribute('open')) onCartEvent();
    });
  } else if (document.getElementById('cart-drawer')?.hasAttribute('open')) {
    onCartEvent();
  }
})();





/* ============================== */
/*  EVENT BINDINGS                */
/* ============================== */
document.addEventListener('DOMContentLoaded',             updateAllTaxesNotices);
document.addEventListener('variant:change',               updateAllTaxesNotices);
document.addEventListener('variant:change',               updateDisplayedPrices);

document.addEventListener('shopify:section:load',         updateAllTaxesNotices);
document.addEventListener('shopify:localization:load',    updateAllTaxesNotices);
document.addEventListener('country:change',               updateAllTaxesNotices);   // legacy

// Cart drawer refresh/update hooks (used by many Shopify themes including Prestige)
document.addEventListener('cart:refresh',                 updateAllTaxesNotices);
document.addEventListener('cart:updated',                 updateAllTaxesNotices);
document.addEventListener('cart:change',                  updateAllTaxesNotices);


